module.exports = __webpack_public_path__ + "img/zizhi.89e14e37.png";